import { render, staticRenderFns } from "./ActionAlert.vue?vue&type=template&id=4b297484&"
import script from "./ActionAlert.vue?vue&type=script&lang=js&"
export * from "./ActionAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports